<template>
  <footer id="newsletter" v-if="!$route.meta.hideFooter" v-lazy:background-image="'/static/img/KMS_Footer_BG.jpg'">
    <div class="social-container">
      <span>Besucht uns auf</span>
      <kms-a to="https://www.facebook.com/KinoMondSterne" class="noStroke"><img v-lazy="'/static/img/facebook_w_circle.svg'" alt="Facebook Logo"/></kms-a>
      <kms-a to="https://www.instagram.com/kinomondundsterne/" class="noStroke"><img v-lazy="'/static/img/instagram_w_circle.svg'" alt="Instagram Logo"/></kms-a>
    </div>
    <div class="footer-container">
      <aside class="sitemap">
        <div class="logo"><kms-a class="noStroke" to="/"><img v-lazy="'/static/img/KMS_logo_white.svg'"  alt="Logo von Kino, Mond & Sterne mit Slogan 'Die Besten Nächte des Jahres'"/></kms-a></div>
        <nav class="sitemap">
          <h2>Sitemap</h2>
          <navigation class="vertical" :menu="1" ></navigation>
        </nav>
        <nav v-if="anyActiveMonth" class="program">
          <h2>Programm</h2>
          <ul>
            <li v-show="active" v-for="(active, month) in projectionMonths" :key="month">
              <kms-a :func="goToProgrammOn" :funcParams="month">{{ month }}</kms-a>
            </li>
          </ul>
        </nav>
      </aside>
      <aside class="nl">
        <h2>Zum Newsletter anmelden und immer gut informiert sein!</h2>
        <newsletter-input></newsletter-input>
      </aside>
      <div class="bottom">
        <ul>
          <li>
            <kms-a to="/partner">Partner</kms-a>
          </li>
        </ul>
        <navigation :menu="2" ></navigation>
      </div>
    </div>
  </footer>
</template>

<script>
import Navigation from '@/components/elements/Navigation.vue';
import NewsletterInput from '@/components/elements/NewsletterInput.vue';

export default {
  components: { Navigation, NewsletterInput },
  data () {
    return {
      projectionMonths: []
    }
  },
  methods: {
    goToProgrammOn: function(month) {
      var vm = this;
      if(vm.$router.currentRoute.name == 'Programm') {
        vm.$event.$emit('filter', {period:[month,month]});
        vm.$event.$emit('move2anchor', 'top');
      } else {
        vm.$router.push('/programm', function() {
          vm.$event.$once('MoviesDataMounted' ,() => { vm.$event.$emit('filter', {period:[month,month]}); });
        });
      }
    }
  },
  computed: {
    anyActiveMonth: function() {
      for(var i in this.projectionMonths) {
        if(this.projectionMonths[i])
          return true;
      }
      return false;
    }
  },
  created() {
    let vm = this;
    vm.$http.get('/projectionMonths').then(result => {
      vm.projectionMonths = result.data;
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

footer{
  background-size:cover;
  background-position: top center;
  padding:2% 5% 1% 5%;
  position: relative;
  @include for-size(phone-only) {
    background-position: 60% 0%;
    font-size: 1.2em;
  }
  &:before{
    content:"";
    position: absolute;
    width:100%;
    height:100%;
    left:0;
    top:0;
    background-color:rgba(0,0,0,0.6);
  }
  .footer-container, .social-container{
    position:relative;
    display:flex;
    flex-flow: row wrap;
    justify-content: space-between;
    width: 100%;
    margin: 5% auto 1% auto;
    &>span{
      font-weight: 800;
      font-size:1em;
    }
    aside{
      width:25%;
      .logo{
        margin-right:25%;
        img {
          width:11em;
          height:auto;
          min-width:120px;
          margin-top:2%;
          @include for-size(phone-only) {
            width:50vw;
            margin:1em 0 2em 0;
          }
        }
      }
      &.sitemap{
          display:flex;
          @include for-size(phone-only) {
            flex-wrap: wrap;
          }
          width:initial;
          min-width:50%;
          .logo{
            @include for-size(phone-only) {
              width:100%;
              text-align: center;
              margin-right:0;
              //margin-bottom:5em;
            }
          }
          nav {
            margin:0 25% 0 0;
            a {
              cursor: pointer;
            }
          }
      }
      h2{
        color:white;
        font-weight:800;
        font-size:1.3em;
        margin-bottom:1em;
      }
      a {
        font-size:1em;
        line-height:2em;
        font-weight: 500;
        color:white;
        white-space: nowrap;
      }

      &.nl{
        p{
          color:white;
        }
      }

    }
    .bottom {
      width:100%;
      flex: 1 100%;
      margin-top:5%;
      color:White;
      display: flex;
      //flex-wrap: wrap;
      justify-content: space-between;
      a{
        margin-left:1.5%;
        color:white;
        white-space: nowrap;
      }
      ul{
          justify-content: flex-end;
          line-height: 2em;
          width:60%;
          flex-wrap: wrap;
          li {
            a{
              line-height: 0;
              vertical-align: super;
            }
          }
      }
    }
  }

  .footer-container{
    @include for-size(phone-only) {
      flex-direction: column;
      .nl{
        width:80%;
        margin:3em auto 0 auto;
      }
    }
  }
  .social-container {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    color: white;
    justify-content: center;
    align-items: center;
    padding-bottom:2%;
    margin:0;
    a{
      margin-left:3%;
      img{
        width:100%;
        transition: transform 0.3s ease;
        &:hover{
          transform: scale(1.1);
        }
      }
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue